/**
 * @generated SignedSource<<90dc919db3fa4da99b783a27b08b3d4d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "portfolioPropertyMemberId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "uuid"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "portfolioPropertyMemberId",
        "variableName": "portfolioPropertyMemberId"
      },
      {
        "kind": "Variable",
        "name": "uuid",
        "variableName": "uuid"
      }
    ],
    "concreteType": "PortfolioPropertyMember",
    "kind": "LinkedField",
    "name": "portfolioRetireProperty",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uuid",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PortfolioRetirePropertyMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PortfolioRetirePropertyMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "f71b2f2ee79307cd76deb309bfe05def",
    "id": null,
    "metadata": {},
    "name": "PortfolioRetirePropertyMutation",
    "operationKind": "mutation",
    "text": "mutation PortfolioRetirePropertyMutation(\n  $uuid: ID!\n  $portfolioPropertyMemberId: ID!\n) {\n  portfolioRetireProperty(uuid: $uuid, portfolioPropertyMemberId: $portfolioPropertyMemberId) {\n    id\n    uuid\n  }\n}\n"
  }
};
})();

node.hash = "9b7b3c97802d45f4d213ea72bf6b0c4e";

module.exports = node;
